export default {
    namespaced: true,
    state: {
        status: false
    },
    mutations: {
        toggleLoadingStatus(state) {
            state.status = !state.status
        },
        setStatus(state, status) {
            state.status = status
        }
    },
    actions: {
        toggleLoadingStatus({commit}) {
            commit('toggleLoadingStatus')
        }
    },
    getters: {
        loadingStatus: state => state.status
    }
}